import React from 'react';
import './HoaLandscapingDetails.css';
import LawnPackageone from './LawnPackageone';

const services = [
  {
    title: 'Routine Maintenance',
    text:
      'We address sidewalk strips, entry areas, and common green spaces by trimming overgrowth, managing weeds, and clearing debris. These services help maintain a clean and orderly presentation.',
  },
  {
    title: 'Mowing & Lawn Care',
    text:
      'We mow shared lawns, park areas, and other grassy spaces at a height intended to support healthy growth. Our approach is designed to encourage consistency in appearance across the property.',
  },
  {
    title: 'Tree & Plant Trimming',
    text:
      'We trim trees and shrubs to reduce overgrowth and improve structure. This includes cutting back limbs that obstruct access or visibility and shaping plants when needed.',
  },
  {
    title: 'Park & Recreation Area Care',
    text:
      'We maintain turf and landscape features in parks and recreational areas. This includes mowing, edging, and rotating seasonal plant material when applicable.',
  },
  {
    title: 'Flower Beds & Mulch',
    text:
      'We maintain flower beds by removing weeds, cultivating soil, and installing or refreshing mulch. When requested, we can also assist with seasonal planting based on the setting and conditions.',
  },
  {
    title: 'Litter & Trash Removal',
    text:
      'We perform litter pickup and debris removal in shared areas such as trails, sidewalks, and community lawns. This helps support a clean, well-maintained environment for residents and visitors.',
  },
];

export default function HoaLandscapingDetails() {
  return (
    <section className="hoa-landscaping">
      <div className="hoa-container">
        <header className="hoa-header">
          <h2 className="hoa-title">HOA Landscaping&nbsp;Maintenance&nbsp;Services</h2>
             <div className="rl-title-underline"></div>
          <p className="hoa-subtitle">
            Primed Landscaping provides landscape maintenance for neighborhoods, HOAs, and shared
            community spaces. Our work supports the appearance and function of parks, walkways, and
            green areas used by residents.
          </p>
        </header>

        <div className="hoa-grid">
          {services.map(({ title, text }) => (
            <article key={title} className="hoa-card">
              <div className="hoa-card__content">
                <h2 className="hoa-card__title">{title}</h2>
                <p className="hoa-card__text">{text}</p>
              </div>
            </article>
          ))}
        </div>
      </div>

      <LawnPackageone />
    </section>
  );
}
